/**
 * External dependencies
 */
import Breadcrumbs from '@Components/Breadcrumbs';
import EventsCalendar from '@Components/EventsCalendar';

export default function EventsCalendarPage() {
  return (
    <div className="w-full">
      <Breadcrumbs
        navList={[
          { name: 'Events', href: '/events' },
          { name: 'Calendar', href: '/events/calendar' },
        ]}
      />
      <div>
        <EventsCalendar />
      </div>
    </div>
  );
}
